define('OutSystems/ReactView/WidgetHelpers',["require", "exports", "react"], function (require, exports, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.wrapElements = void 0;
    function wrapElements(elements, key) {
        if (key === void 0) { key = "i-default"; }
        if (Array.isArray(elements)) {
            var fragmentObj_1 = {};
            for (var i = 0; i < elements.length; i++) {
                fragmentObj_1["i" + i] = elements[i];
            }
            return React.createElement(React.Fragment, { key: key }, Object.keys(fragmentObj_1).map(function (key) { return React.createElement(React.Fragment, { key: key }, fragmentObj_1[key]); }));
        }
        return elements;
    }
    exports.wrapElements = wrapElements;
});
//# sourceMappingURL=WidgetHelpers.js.map;
